import React from "react";
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DeliveryCollectionForm from "./DeliveryCollectionComponents/DeliveryCollectionForm";

import {
  useGetDeliveryCollectionDetailQuery,
  useUpdateDeliveryCollectionMutation,
} from "store/services/deliveryCollectionApi";

const DeliveryCollectionEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Delivery Collections", path: "/app/crm/delivery-collection/list" },
    { title: "Edit Delivery Collection" },
  ];

  const {
    data: deliveryCollectionDetail,
    isLoading: loadingDeliveryCollection,
    error,
  } = useGetDeliveryCollectionDetailQuery(id);

  const [updateDeliveryCollection, { isLoading: updatingDeliveryCollection }] =
    useUpdateDeliveryCollectionMutation();

  const handleUpdateDeliveryCollection = async (data) => {
    const _payload = { ...data, _id: id };

    try {
      await updateDeliveryCollection(_payload).unwrap();
      toast.success("Delivery Collection successfully updated!");
      navigate(`/app/crm/delivery-collection/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Delivery Collection!"
      );
    }
  };

  useAppMeta("Edit Delivery Collection");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingDeliveryCollection || updatingDeliveryCollection}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <DeliveryCollectionForm
          isBusy={loadingDeliveryCollection || updatingDeliveryCollection}
          deliveryCollectionDetail={deliveryCollectionDetail}
          onSubmit={handleUpdateDeliveryCollection}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DeliveryCollectionEditScreen;